import apiClient, { unwrapData } from "./apiClient";

export async function getLeadContextStatus(options = {}) {
  const response = await apiClient.get("/api/lead-context/status", options);
  return unwrapData(response);
}

export async function getLeadContextLeads(options = {}) {
  const response = await apiClient.get("/api/lead-context/leads", options);

  return unwrapData(response);
}

export async function uploadLeadContext(formData, options = {}) {
  const response = await apiClient.upload("/api/lead-context/upload", {
    ...options,
    formData,
  });

  return unwrapData(response);
}

export async function setLeadContextEnabled(enabled, options = {}) {
  const response = await apiClient.patch("/api/lead-context/status", {
    ...options,
    body: {
      enabled: Boolean(enabled),
    },
  });

  return unwrapData(response);
}

export async function triggerLeadContextSync(options = {}) {
  const response = await apiClient.post("/api/lead-context/sync", {
    ...options,
    body: {},
  });

  return unwrapData(response);
}
